export const roundOffTwoDP = function (number, places = 2) {
    return parseFloat(number).toFixed(places)
}